import type { TOC } from '@ember/component/template-only';
import { or } from 'ember-truth-helpers';

import EmberTooltip from '../ember-tooltip.gts';

interface PrismTooltipSignature {
  Args: {
    delay?: number;
    isShown?: boolean;
    onShow?: () => void;
    side?: 'top' | 'bottom' | 'left' | 'right';
    text: string;
    title?: string;
  };
}

const PrismTooltip: TOC<PrismTooltipSignature> = <template>
  <EmberTooltip
    @arrowClass="prism-tooltip__arrow"
    @delay={{@delay}}
    @isShown={{@isShown}}
    @onShow={{@onShow}}
    @side={{or @side "top"}}
    @tooltipClass="prism-tooltip"
  >
    {{#if @title}}
      <p class="text-200--bold prism-tooltip__title">
        {{@title}}
      </p>
    {{/if}}

    <p class="paragraph-200--regular">
      {{@text}}
    </p>
  </EmberTooltip>
</template>;

export default PrismTooltip;
